<template>
  <div class="talentRecommend">
    <el-form :model="talentRecommendObj" label-width="120px" :rules="talentRecommendRules">
      <title-bar title="公司信息" />
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="公司名称：">
            <el-input v-model="talentRecommendObj.corporateName" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="应聘职位：">
            <el-input v-model="talentRecommendObj.recruitmentPosition" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="项目顾问：">
            <el-input
              v-model="talentRecommendObj.projectConsultant"
              placeholder="请输入"
            /> </el-form-item
        ></el-col>
        <el-col :span="8">
          <el-form-item label="人才供应商：">
            <el-input
              v-model="talentRecommendObj.talentSupplier"
              placeholder="请输入"
            /> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="日期：">
            <el-date-picker
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="talentRecommendObj.dateTime"
              type="date"
              placeholder="请选择"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <title-bar title="个人信息" />
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="姓名：">
            <el-input v-model="talentRecommendObj.name" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年龄：">
            <el-input v-model.number="talentRecommendObj.age" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="婚姻状态：">
            <el-radio-group v-model="talentRecommendObj.weddingOrNot">
              <el-radio :label="1">未婚</el-radio>
              <el-radio :label="0">已婚</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="100">
        <el-col :span="8">
          <el-form-item label="语言能力：">
            <el-input v-model="talentRecommendObj.languageAbility" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="所在地：">
            <CascaderArea
              :country="talentRecommendObj.personCountry"
              :province="talentRecommendObj.personProvince"
              :city="talentRecommendObj.personCity"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <title-bar title="教育背景" />
      <div class="common-style">
        <el-table :data="personEducational" border>
          <el-table-column prop="date" label="时间" width="200">
            <template v-slot="{ row }">
              <div>{{ row.startDate }}~{{ row.endDate }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="schoolName" label="学校" width="180" />
          <el-table-column prop="education" label="学历" />
          <el-table-column prop="major" label="专业" />
        </el-table>
      </div>
      <title-bar title="工作经历及内容" />
      <div v-for="(item, index) in personExperience" :key="index">
        <content-bar
          :startTime="item.inductionTime"
          :endTime="item.quitTime"
          :contentName="item.companyName"
          :position="item.position"
          contentTitle="职位内容"
          :content="item.operatingDuty"
        />
      </div>
      <title-bar title="部分项目" />
      <div v-for="(item, index) in personProjectExperience" :key="index + new Date().getTime()">
        <content-bar
          :startTime="item.startTime"
          :endTime="item.endTime"
          :contentName="item.projectName"
          :position="item.projectFunction"
          contentTitle="项目内容"
          :content="item.projectAchievement"
        />
      </div>
      <title-bar title="技术能力" />
      <div class="common-style">
        <el-tag v-for="(item, index) in talentRecommendObj.listTechnique" :key="index">
          {{ item }}
        </el-tag>
      </div>
      <title-bar title="专业认证" />
      <div class="common-style">
        <el-table :data="certifications" border>
          <el-table-column prop="date" label="时间">
            <template v-slot="{ row }">
              <div>{{ row.startTime }}~{{ row.endTime }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="certificateName" label="证书" />
        </el-table>
      </div>
      <title-bar title="业界荣誉" />
      <div class="common-style">
        <el-tag v-for="(item, index) in talentRecommendObj.listHonor" :key="index">
          {{ item }}
        </el-tag>
      </div>
      <title-bar title="目前工资" />
      <el-form-item
        v-if="talentRecommendObj.isYears !== 0 && talentRecommendObj.isYears !== 1"
        :label="talentRecommendObj.isYears ? '年薪：' : '月薪：'"
      >
        <el-input
          class="mini-input"
          v-model="talentRecommendObj.currentSalaryStart"
          placeholder="请输入"
        />&nbsp;~
        <el-input
          class="mini-input"
          v-model="talentRecommendObj.currentSalaryEnd"
          placeholder="请输入"
        />
      </el-form-item>
      <title-bar title="期望工资" />
      <el-form-item
        v-if="talentRecommendObj.isAnnual !== 0 && talentRecommendObj.isAnnual !== 1"
        :label="talentRecommendObj.isAnnual ? '年薪：' : '月薪：'"
      >
        <el-input
          class="mini-input"
          v-model="talentRecommendObj.salaryExpectation"
          placeholder="请输入"
        />&nbsp;~
        <el-input
          class="mini-input"
          v-model="talentRecommendObj.salaryExpectationEnd"
          placeholder="请输入"
        />
      </el-form-item>
      <title-bar title="入职时间" />
      <div class="common-style">
        <el-tag v-if="talentRecommendObj.entryTime">{{ talentRecommendObj.entryTime }}</el-tag>
      </div>
      <el-form-item label="人才评估：" prop="other">
        <el-input
          v-model="talentRecommendObj.other"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入"
        />
      </el-form-item>
      <div class="control-btn">
        <el-button type="primary" @click="saveTalent">保存</el-button>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary">下载</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import CascaderArea from '@/components/CascaderArea.vue'
import TitleBar from '@/components/TitleBar.vue'
import contentBar from './cpns/contentBar.vue'
import { getTalentRecommend, addTalentRecommend } from '@/api/projectCenter'

export default {
  name: 'TalentRecommend',

  components: {
    TitleBar,
    CascaderArea,
    contentBar
  },

  props: {
    currentTab: {
      type: String
    },
    personCode: {
      type: String,
      required: true
    },
    projectId: {
      type: Number
    },
    talentInfo: {
      type: Object
    },
    companyInfo: {
      type: Object
    }
  },

  data() {
    return {
      talentRecommendObj: {
        corporateName: '', // 公司名称
        talentSupplier: '菁锐人才', // 人才供应商
        recruitmentPosition: '', // 应聘职位
        projectConsultant: '', // 项目顾问
        dateTime: this.$df(new Date().getTime(), 'yyyy-mm-dd'), // 日期
        name: '', // 姓名
        age: '', // 年龄
        languageAbility: '', // 语言能力
        weddingOrNot: '', // 婚姻状态
        personCountry: '', // 国家
        personProvince: '', // 省份
        personCity: '', // 城市
        isAnnual: null, // 期望月薪/年薪
        salaryExpectation: '', // 期望开始薪资
        salaryExpectationEnd: '', // 期望结束薪资
        isYears: null, // 目前月薪/年薪
        currentSalaryStart: '', // 目前开始薪资
        currentSalaryEnd: '', // 目前结束薪资
        other: '', // 人才评估
        entryTime: '', // 后端接受入职时间
        hiredate: '', // 前端展示入职时间
        listTechnique: [], // 技术能力
        listHonor: [] // 业界荣誉
      },
      // 教育经历
      personEducational: [],
      // 工作经历
      personExperience: [],
      // 项目经历
      personProjectExperience: [],
      // 专业认证
      certifications: [],
      id: '',
      talentRecommendRules: {
        other: [{ required: true, message: '请输入人才评估', trigger: 'blur' }]
      }
    }
  },

  watch: {
    currentTab: {
      handler: function (newVal) {
        if (newVal === 'first') {
          this.search()
        }
      },
      immediate: true
    },
    talentInfo: {
      handler(newVal) {
        Object.keys(newVal).forEach((item) => {
          if (this.talentRecommendObj.hasOwnProperty(item)) {
            this.talentRecommendObj[item] = newVal[item]
          }
        })
        this.personEducational = newVal.personEducational
        this.personProjectExperience = newVal.personProjectExperience
        this.personExperience = newVal.personExperience
        this.certifications = newVal.certifications
      },
      immediate: true
    },
    companyInfo: {
      handler(newVal) {
        Object.keys(newVal).forEach((item) => {
          if (this.talentRecommendObj.hasOwnProperty(item)) {
            this.talentRecommendObj[item] = newVal[item]
          }
        })
      },
      immediate: true
    }
  },

  methods: {
    async search() {
      const { data: res } = await getTalentRecommend({ id: this.personCode })
      if (res.resultCode === 200) {
        if (res.data) {
          console.log(res.data)
          // this.talentRecommendObj.other = res.data.other
          this.id = res.data.id
        }
      }
    },
    async saveTalent() {
      const { data: res } = await addTalentRecommend({
        personnelId: this.personCode,
        projectId: this.projectId,
        id: this.id,
        other: this.talentRecommendObj.other
      })
      if (res.resultCode === 200) {
        this.$message.success('操作成功')
        this.$router.go(-1)
      }
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.talentRecommend {
  background: #fff;
  padding: 20px 10px;
  .common-style {
    margin: 0 30px 20px;
  }
  .control-btn {
    text-align: center;
  }
}
</style>
